export default "__VITE_ASSET__CNixyXwo__"